export const selectorDefaultSettings = {
  opener: 'auto',
  placeholder: "default",
  search_api_feed: ''
}